import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { Equalizer } from '@material-ui/icons'
import { H6, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { reportTypeList } from '../Tools/UploadDashboardReport'
import { getLatestDashboardHtmlFileApi } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { Text } from '@styles'
import { isSuperAdminOnly } from 'src/utils/adminFilter'
import { paths } from '@routes'
import { useNavigate } from 'react-router'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`

const Frame = styled.iframe`
	width: 100%;
	flex: 1;
	border: 0;
`

const EmptyStateWrapper = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 5rem;
	gap: 0.75rem;
	color: ${({ theme }) => theme.palette.text.label};

	& > svg {
		font-size: 4rem;
		fill: ${({ theme }) => theme.palette.background.disabled};
	}
`

const EmptyStateText = styled(H6)`
	font-size: ${Text.XX_LARGE};
	font-weight: ${Text.BOLD_600};
	line-height: ${Text.LINE_HEIGHT_MAX};
	color: ${({ theme }) => theme.palette.text.label};
`

const DailyStandup = () => {
	const dispatch = useDispatch()
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const navigate = useNavigate()
	const [html, setHtml] = useState('')

	useEffect(() => {
		dispatch(showLoader(true))
		getLatestDashboardHtmlFileApi(reportTypeList?.[0]?.key)
			.then((response) => setHtml(response))
			.catch(() => {
				dispatch(showToast(true, strings('no_data_found'), { type: TOAST_TYPE.ERROR }))
				setHtml('')
			})
			.finally(() => dispatch(showLoader(false)))
	}, [])

	if (!isSuperAdminOnly(user.role)) {
		navigate(paths.admin_dashboard_all)
	}

	return (
		<Wrapper>
			{html ? (
				<Frame title='daily-standup' srcDoc={html} />
			) : (
				<EmptyStateWrapper>
					<Equalizer />
					<EmptyStateText>No data found</EmptyStateText>
				</EmptyStateWrapper>
			)}
		</Wrapper>
	)
}

export default DailyStandup
